import { render } from "./message-datetime.vue?vue&type=template&id=7766ffd8&scoped=true"
import script from "./message-datetime.vue?vue&type=script&lang=js"
export * from "./message-datetime.vue?vue&type=script&lang=js"

import "./message-datetime.vue?vue&type=style&index=0&id=7766ffd8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7766ffd8"]])

export default __exports__